export default class RequestDetailsForReplyDto {
  /**
   * @type {number}
   */
  requestId;

  /**
   * @type {string}
   */
  accessCode;

  /**
   * @type {string}
   */
  message = '';

  /**
   * @type {string[]}
   */
  files = [];

  constructor(opts = null) {
    if (opts != null) {
      if (opts.requestId != null) {
        this.requestId = opts.requestId;
      }
      if (opts.accessCode != null) {
        this.accessCode = opts.accessCode;
      }
      if (opts.message != null) {
        this.message = opts.message;
      }
      if (opts.files != null) {
        this.files = opts.files;
      }
    }
  }
}
